import {
  ECA_CREATE_PROGRAM,
  ECA_CREATE_PROGRAM_SUCCESS,
  // ECA_CREATE_PROGRAM_FAILURE,
  ECA_LIST_PROGRAMS,
  ECA_LIST_PROGRAMS_SUCCESS,
  // ECA_LIST_PROGRAMS_FAILURE,
  ECA_PROGRAM_DETAILS,
  ECA_PROGRAM_DETAILS_SUCCESS,
  // ECA_PROGRAM_DETAILS_FAILURE,
  ECA_UPDATE_PROGRAM,
  ECA_UPDATE_PROGRAM_SUCCESS,
  // ECA_UPDATE_PROGRAM_FAILURE,
  ECA_DELETE_PROGRAM,
  ECA_DELETE_PROGRAM_SUCCESS,
  // ECA_DELETE_PROGRAM_FAILURE,
  ECA_CREATE_ACTIVITY,
  ECA_CREATE_ACTIVITY_SUCCESS,
  // ECA_CREATE_ACTIVITY_FAILURE,
  // ECA_LIST_ACTIVITIES,
  // ECA_LIST_ACTIVITIES_SUCCESS,
  // ECA_LIST_ACTIVITIES_FAILURE,
  ECA_ACTIVITY_DETAILS,
  ECA_ACTIVITY_DETAILS_SUCCESS,
  // ECA_ACTIVITY_DETAILS_FAILURE,
  ECA_ACTIVITY_EVENTS_PARTICIPANTS,
  ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS,
  // ECA_ACTIVITY_EVENTS_PARTICIPANTS_FAILURE,
  ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS,
  ECA_UPDATE_ACTIVITY,
  ECA_UPDATE_ACTIVITY_SUCCESS,
  // ECA_UPDATE_ACTIVITY_FAILURE,
  ECA_DELETE_ACTIVITY,
  ECA_DELETE_ACTIVITY_SUCCESS,
  // ECA_DELETE_ACTIVITY_FAILURE,
  ECA_ADD_ACTIVITY_PARTICIPANTS,
  ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_ADD_ACTIVITY_PARTICIPANTS_FAILURE,
  ECA_DELETE_ACTIVITY_PARTICIPANTS,
  ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_DELETE_ACTIVITY_PARTICIPANTS_FAILURE,
  ECA_ADD_ACTIVITY_LEADS,
  ECA_ADD_ACTIVITY_LEADS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_ADD_ACTIVITY_LEADS_FAILURE,
  ECA_DELETE_ACTIVITY_LEADS,
  ECA_DELETE_ACTIVITY_LEADS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_DELETE_ACTIVITY_LEADS_FAILURE,
  ECA_FETCH_AND_SHOW_ACTIVITY_LEADS,
  ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS,
  ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS,
  ECA_CREATE_EVENT,
  ECA_CREATE_EVENT_SUCCESS,
  // ECA_CREATE_EVENT_FAILURE,
  // ECA_LIST_EVENTS,
  // ECA_LIST_EVENTS_SUCCESS,
  // ECA_LIST_EVENTS_FAILURE,
  ECA_EVENT_DETAILS,
  ECA_EVENT_DETAILS_SUCCESS,
  // ECA_EVENT_DETAILS_FAILURE,
  ECA_UPDATE_EVENT,
  ECA_UPDATE_EVENT_SUCCESS,
  // ECA_UPDATE_EVENT_FAILURE,
  ECA_DELETE_EVENT,
  ECA_DELETE_EVENT_SUCCESS,
  // ECA_DELETE_EVENT_FAILURE,
  ECA_ADD_EVENT_PARTICIPANTS,
  ECA_ADD_EVENT_PARTICIPANTS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_ADD_EVENT_PARTICIPANTS_FAILURE,
  ECA_DELETE_EVENT_PARTICIPANTS,
  ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_DELETE_EVENT_PARTICIPANTS_FAILURE,
  ECA_UPDATE_PARTICIPANT_NEXT,
  ECA_ADD_EVENT_COORDINATORS,
  ECA_ADD_EVENT_COORDINATORS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_ADD_EVENT_COORDINATORS_FAILURE,
  ECA_DELETE_EVENT_COORDINATORS,
  ECA_DELETE_EVENT_COORDINATORS_SUCCESS,
  // eslint-disable-next-line no-unused-vars -- imported, no action creator/reducer case; missing FAILURE handler, see PROGRESS.md Task 6b
  ECA_DELETE_EVENT_COORDINATORS_FAILURE,
  ECA_FETCH_AND_SHOW_EVENT_COORDINATORS,
  ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS,
  ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS,
  ECA_MODAL_SHOW_EDIT_PROGRAM,
  ECA_MODAL_HIDE_EDIT_PROGRAM,
  ECA_MODAL_SHOW_EDIT_ACTIVITY,
  ECA_MODAL_HIDE_EDIT_ACTIVITY,
  ECA_MODAL_SHOW_EDIT_EVENT,
  ECA_MODAL_HIDE_EDIT_EVENT,
  ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS,
  ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS,
  ECA_MODAL_SHOW_EVENT_PARTICIPANTS,
  ECA_MODAL_HIDE_EVENT_PARTICIPANTS,
  SEARCH_PUPILS_FOR_EVENT,
  ECA_TODAY_EVENTS,
  ECA_TODAY_EVENTS_SUCCESS,
  ECA_SEARCH_EVENTS_BY_PARTICPANTS,
  ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS,
  CLEAR_FETCHED_EVENTS,
  GET_EVENTS_HISTORY,
  GET_EVENTS_HISTORY_SUCCESS,
  GET_EVENTS_HISTORY_FAILURE,
  SHOW_EVENTS_HISTORY_LOADER,
  HIDE_EVENTS_HISTORY_LOADER,
  GET_EVENT_HISTORY_TABS,
  GET_EVENT_HISTORY_TABS_SUCCESS,
  GET_EVENT_HISTORY_TABS_FAILURE,
  GET_EVENT_HISTORY_TAB_DATA,
  GET_EVENT_HISTORY_TAB_DATA_SUCCESS,
  GET_EVENT_HISTORY_TAB_DATA_FAILURE,
  CLEAR_EVENT_HISTORY_TAB_DATA,
} from 'constants/ActionTypes';

export const createProgram = program => ({
  type: ECA_CREATE_PROGRAM,
  payload: { program },
});
export const createProgramSuccess = program => ({
  type: ECA_CREATE_PROGRAM_SUCCESS,
  payload: { program },
});
export const updateProgram = program => ({
  type: ECA_UPDATE_PROGRAM,
  payload: { program },
});
export const updateProgramSuccess = program => ({
  type: ECA_UPDATE_PROGRAM_SUCCESS,
  payload: { program },
});
export const deleteProgram = programId => ({
  type: ECA_DELETE_PROGRAM,
  payload: { programId },
});
export const deleteProgramSuccess = programId => ({
  type: ECA_DELETE_PROGRAM_SUCCESS,
  payload: { programId },
});
export const listPrograms = () => ({
  type: ECA_LIST_PROGRAMS,
});
export const listProgramsSuccess = programs => ({
  type: ECA_LIST_PROGRAMS_SUCCESS,
  payload: { programs },
});
export const programDetails = programId => ({
  type: ECA_PROGRAM_DETAILS,
  payload: { programId },
});
export const programDetailsSuccess = program => ({
  type: ECA_PROGRAM_DETAILS_SUCCESS,
  payload: { program },
});

export const createActivity = activity => ({
  type: ECA_CREATE_ACTIVITY,
  payload: { activity },
});
export const createActivitySuccess = activity => ({
  type: ECA_CREATE_ACTIVITY_SUCCESS,
  payload: { activity },
});
export const updateActivity = activity => ({
  type: ECA_UPDATE_ACTIVITY,
  payload: { activity },
});
export const updateActivitySuccess = activity => ({
  type: ECA_UPDATE_ACTIVITY_SUCCESS,
  payload: { activity },
});
export const deleteActivity = activityId => ({
  type: ECA_DELETE_ACTIVITY,
  payload: { activityId },
});
export const deleteActivitySuccess = activityId => ({
  type: ECA_DELETE_ACTIVITY_SUCCESS,
  payload: { activityId },
});
export const activityDetails = activityId => ({
  type: ECA_ACTIVITY_DETAILS,
  payload: { activityId },
});
export const activityDetailsSuccess = activity => ({
  type: ECA_ACTIVITY_DETAILS_SUCCESS,
  payload: { activity },
});
export const activityEventsParticipants = activityId => ({
  type: ECA_ACTIVITY_EVENTS_PARTICIPANTS,
  payload: { activityId },
});
export const activityEventsParticipantsSuccess = participants => ({
  type: ECA_ACTIVITY_EVENTS_PARTICIPANTS_SUCCESS,
  payload: { participants },
});
export const clearActivityEventsParticipants = () => ({
  type: ECA_CLEAR_ACTIVITY_EVENTS_PARTICIPANTS,
});
export const addActivityParticipants = (activityId, pupilIds) => ({
  type: ECA_ADD_ACTIVITY_PARTICIPANTS,
  payload: { id: activityId, pupilIds },
});
export const addActivityParticipantsSuccess = activity => ({
  type: ECA_ADD_ACTIVITY_PARTICIPANTS_SUCCESS,
  payload: { activity },
});
export const deleteActivityParticipants = (activityId, pupilIds) => ({
  type: ECA_DELETE_ACTIVITY_PARTICIPANTS,
  payload: { id: activityId, pupilIds },
});
export const deleteActivityParticipantsSuccess = activity => ({
  type: ECA_DELETE_ACTIVITY_PARTICIPANTS_SUCCESS,
  payload: { activity },
});
export const addActivityLeads = (activityId, staffIds) => ({
  type: ECA_ADD_ACTIVITY_LEADS,
  payload: { id: activityId, staffIds },
});
export const addActivityLeadsSuccess = activity => ({
  type: ECA_ADD_ACTIVITY_LEADS_SUCCESS,
  payload: { activity },
});
export const deleteActivityLeads = (activityId, staffIds) => ({
  type: ECA_DELETE_ACTIVITY_LEADS,
  payload: { id: activityId, staffIds },
});
export const deleteActivityLeadsSuccess = activity => ({
  type: ECA_DELETE_ACTIVITY_LEADS_SUCCESS,
  payload: { activity },
});
export const fetchAndShowLeadsForActivityId = activityId => ({
  type: ECA_FETCH_AND_SHOW_ACTIVITY_LEADS,
  payload: { activityId },
});
export const fetchActivityLeadsSuccess = activity => ({
  type: ECA_FETCH_AND_SHOW_ACTIVITY_LEADS_SUCCESS,
  payload: { activity },
});
export const hideAndClearActivityLeads = () => ({
  type: ECA_HIDE_AND_CLEAR_ACTIVITY_LEADS,
});
export const createEvent = event => ({
  type: ECA_CREATE_EVENT,
  payload: { event },
});
export const createEventSuccess = event => ({
  type: ECA_CREATE_EVENT_SUCCESS,
  payload: { event },
});
export const updateEvent = (event, propagateStateEventDetails, fetchEventDetails) => ({
  type: ECA_UPDATE_EVENT,
  payload: { event, fetchEventDetails, propagateStateEventDetails },
});
export const updateParticipantNext = (eventId, participantId, preference) => ({
  type: ECA_UPDATE_PARTICIPANT_NEXT,
  payload: { eventId, participantId, preference },
});
export const updateEventSuccess = (event, propagateStateEventDetails) => ({
  type: ECA_UPDATE_EVENT_SUCCESS,
  payload: { event, propagateStateEventDetails },
});
export const deleteEvent = eventId => ({
  type: ECA_DELETE_EVENT,
  payload: { eventId },
});
export const deleteEventSuccess = eventId => ({
  type: ECA_DELETE_EVENT_SUCCESS,
  payload: { eventId },
});
export const eventDetails = (eventId, fetchActive) => ({
  type: ECA_EVENT_DETAILS,
  payload: { eventId, fetchActive },
});
export const eventDetailsSuccess = event => ({
  type: ECA_EVENT_DETAILS_SUCCESS,
  payload: { event },
});
export const addEventParticipants = (eventId, pupilIds) => ({
  type: ECA_ADD_EVENT_PARTICIPANTS,
  payload: { id: eventId, pupilIds },
});
export const addEventParticipantsSuccess = event => ({
  type: ECA_ADD_EVENT_PARTICIPANTS_SUCCESS,
  payload: { event },
});
export const deleteEventParticipants = (eventId, pupilIds) => ({
  type: ECA_DELETE_EVENT_PARTICIPANTS,
  payload: { id: eventId, pupilIds },
});
export const deleteEventParticipantsSuccess = event => ({
  type: ECA_DELETE_EVENT_PARTICIPANTS_SUCCESS,
  payload: { event },
});
export const searchPupilsForEvent = (filter, selectedPupilsIds) => ({
  type: SEARCH_PUPILS_FOR_EVENT,
  payload: { filter, selectedPupilsIds },
});
export const searchEventsByParticipants = participantIds => ({
  type: ECA_SEARCH_EVENTS_BY_PARTICPANTS,
  payload: { participantIds },
});
export const searchEventsByParticipantsSuccess = (fetchedEvents, pageCount) => ({
  type: ECA_SEARCH_EVENTS_BY_PARTICPANTS_SUCCESS,
  payload: { fetchedEvents, pageCount },
});
export const clearFetchedEvents = () => ({
  type: CLEAR_FETCHED_EVENTS,
});
export const addEventCoordinators = (eventId, staffIds) => ({
  type: ECA_ADD_EVENT_COORDINATORS,
  payload: { id: eventId, staffIds },
});
export const addEventCoordinatorsSuccess = event => ({
  type: ECA_ADD_EVENT_COORDINATORS_SUCCESS,
  payload: { event },
});
export const deleteEventCoordinators = (eventId, staffIds) => ({
  type: ECA_DELETE_EVENT_COORDINATORS,
  payload: { id: eventId, staffIds },
});
export const deleteEventCoordinatorsSuccess = event => ({
  type: ECA_DELETE_EVENT_COORDINATORS_SUCCESS,
  payload: { event },
});
export const fetchAndShowCoordinatorsForEventId = eventId => ({
  type: ECA_FETCH_AND_SHOW_EVENT_COORDINATORS,
  payload: { eventId },
});
export const fetchEventCoordinatorsSuccess = event => ({
  type: ECA_FETCH_AND_SHOW_EVENT_COORDINATORS_SUCCESS,
  payload: { event },
});
export const getTodayEvents = () => ({
  type: ECA_TODAY_EVENTS,
});
export const todayEventsSuccess = events => ({
  type: ECA_TODAY_EVENTS_SUCCESS,
  payload: { todayEvents: events },
});
export const hideAndClearEventCoordinators = () => ({
  type: ECA_HIDE_AND_CLEAR_EVENT_COORDINATORS,
});
export const showEditProgram = () => ({
  type: ECA_MODAL_SHOW_EDIT_PROGRAM,
});
export const hideEditProgram = () => ({
  type: ECA_MODAL_HIDE_EDIT_PROGRAM,
});
export const showEditActivity = () => ({
  type: ECA_MODAL_SHOW_EDIT_ACTIVITY,
});
export const hideEditActivity = () => ({
  type: ECA_MODAL_HIDE_EDIT_ACTIVITY,
});
export const showEditEvent = () => ({
  type: ECA_MODAL_SHOW_EDIT_EVENT,
});
export const hideEditEvent = () => ({
  type: ECA_MODAL_HIDE_EDIT_EVENT,
});
export const showActivityParticipants = () => ({
  type: ECA_MODAL_SHOW_ACTIVITY_PARTICIPANTS,
});
export const hideActivityParticipants = () => ({
  type: ECA_MODAL_HIDE_ACTIVITY_PARTICIPANTS,
});
export const showEventParticipants = () => ({
  type: ECA_MODAL_SHOW_EVENT_PARTICIPANTS,
});
export const hideEventParticipants = () => ({
  type: ECA_MODAL_HIDE_EVENT_PARTICIPANTS,
});

// ECA History Actions
export const getEventsHistory = (query = {}, params = {}, affectQuery = false) => ({
  type: GET_EVENTS_HISTORY,
  payload: { query, params, affectQuery },
});

export const getEventsHistorySuccess = (items = [], pageCount = 1) => ({
  type: GET_EVENTS_HISTORY_SUCCESS,
  payload: { items, pageCount },
});

export const getEventsHistoryFailure = error => ({
  type: GET_EVENTS_HISTORY_FAILURE,
  payload: { error },
});

export const showEventsHistoryLoader = () => ({
  type: SHOW_EVENTS_HISTORY_LOADER,
});

export const hideEventsHistoryLoader = () => ({
  type: HIDE_EVENTS_HISTORY_LOADER,
});

// ECA History Tabs Actions
export const getEventHistoryTabs = () => ({
  type: GET_EVENT_HISTORY_TABS,
});

export const getEventHistoryTabsSuccess = tabs => ({
  type: GET_EVENT_HISTORY_TABS_SUCCESS,
  payload: { tabs },
});

export const getEventHistoryTabsFailure = error => ({
  type: GET_EVENT_HISTORY_TABS_FAILURE,
  payload: { error },
});

// ECA History Tab Data Actions
export const getEventHistoryTabData = (eventId, tabPath, query) => ({
  type: GET_EVENT_HISTORY_TAB_DATA,
  payload: { eventId, tabPath, query },
});

export const getEventHistoryTabDataSuccess = (tabPath, data) => ({
  type: GET_EVENT_HISTORY_TAB_DATA_SUCCESS,
  payload: { tabPath, data },
});

export const getEventHistoryTabDataFailure = (tabPath, error) => ({
  type: GET_EVENT_HISTORY_TAB_DATA_FAILURE,
  payload: { tabPath, error },
});

export const clearEventHistoryTabData = () => ({
  type: CLEAR_EVENT_HISTORY_TAB_DATA,
});
